var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        _setup.Button,
        {
          nativeOn: {
            click: function ($event) {
              return _setup.goToComponentFields.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "bi-pencil-square me-2" }),
          _vm._v("\n    Fields\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }